export { default as QuickBookingDots } from './QuickBookingDots'
export { default as QuickBookingDotsSkeleton } from './Skeleton'
